// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0bdc3499","513":"e4b8b4c4","703":"8084ba06"}[chunkId] + ".chunk.js";
};